import { render, staticRenderFns } from "./PracticeSeafaringDetailsContent.vue?vue&type=template&id=6ec6f363"
import script from "./PracticeSeafaringDetailsContent.vue?vue&type=script&lang=ts"
export * from "./PracticeSeafaringDetailsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports